// Copied from AssetModal/Header/components/EditableAssetModalHeaderTitle.tsx
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InlineInput } from "@air/component-inline-input";
import { Button } from "@air/primitive-button";
import { tailwindMerge } from "@air/tailwind-variants";
import classNames from "classnames";
import { memo, useEffect, useState } from "react";
export const EditableAssetTitle = /*#__PURE__*/ memo((param)=>{
    let { onSubmit, defaultValue, validate, className } = param;
    const [isEditing, setIsEditing] = useState(false);
    const [value, setValue] = useState(defaultValue);
    useEffect(()=>{
        setValue(defaultValue);
    }, [
        defaultValue
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "flex w-full flex-col gap-1",
        children: /*#__PURE__*/ _jsxs("div", {
            className: tailwindMerge("relative", className),
            "data-testid": "ASSET_TITLE",
            children: [
                /*#__PURE__*/ _jsx(Button, {
                    "data-testid": "EDITABLE_ASSET_TITLE_BUTTON",
                    className: classNames("h-8 w-full justify-start pl-0 text-16 md:h-9 md:text-20", !value && "min-w-[130px] md:min-w-[150px]"),
                    appearance: "ghost",
                    color: "grey",
                    onClick: ()=>setIsEditing(true),
                    children: /*#__PURE__*/ _jsx("span", {
                        className: "truncate",
                        children: value
                    })
                }),
                isEditing && /*#__PURE__*/ _jsx("div", {
                    className: "absolute inset-0 ml-px",
                    children: /*#__PURE__*/ _jsx(InlineInput, {
                        rows: 1,
                        allowNewLines: false,
                        label: "Asset name",
                        onSubmit: (value)=>{
                            setIsEditing(false);
                            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(value);
                        },
                        onCancel: ()=>{
                            setValue(defaultValue);
                            setIsEditing(false);
                        },
                        onChange: setValue,
                        className: "h-full",
                        inputClassName: "font-semibold text-16 md:text-20 h-8 md:h-9 md:py-0.5 leading-[30px] md:leading-[inherit] pl-0",
                        defaultValue: value,
                        "data-testid": "ASSET_TITLE_INPUT",
                        placeholder: "Enter a name",
                        validate: validate
                    })
                })
            ]
        })
    });
});
EditableAssetTitle.displayName = "EditableAssetTitle";
